<template>
  <div class="contact_separator">
    <img src="@/assets/EmilyLogoPNG-10.png" alt="Logo" />
    <div class="contact_text">
      <h1>Contact Me</h1>
      <router-link class="contact_link" to="/contact"
        >Click Here...</router-link
      >
    </div>
  </div>
</template>

<script src="./Contact.js"></script>
<style src="./Contact.scss" lang="scss" scoped></style>